import React, { useEffect , useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom'
import { Modal } from 'react-responsive-modal';
import { isEmpty } from 'lodash';
import { categoryEvent } from "../actions/api-wisdom";
import ReactTooltip from "react-tooltip";
import { ToastContainer, toast } from 'react-toastify';
import 'rc-datepicker/lib/style.css';
import { useWish } from '../hooks';

const Upcoming = (props) => {
	const dispatch = useDispatch();
  	const wisdom = useSelector(state => state),
    { wisdomReducer } = wisdom,
    { category_event } = wisdomReducer;
	
    const [category,setCategory]=useState([]);
	useEffect(() => {
		document.title = "Upcoming Events | Matangi";
		localStorage.removeItem("navtype");
  		localStorage.removeItem("event_id");
		dispatch(categoryEvent());
	}, [dispatch]);

	useEffect(() => {
        if(!isEmpty(category_event)) {
			setCategory(category_event.data);
		}
	}, [category_event]);

	const feedcheck = localStorage.getItem("reg_id");
    if(feedcheck !=0){
      const program_id = localStorage.getItem("regprogram_id");
      if(program_id ==1){
        props.history.push("/ulchemy-feedback");
        window.location.reload();
      }
      if(program_id ==2){
        props.history.push("/ulchemyelite-feedback");
        window.location.reload();
      }
      if(program_id ==3){
        props.history.push("/divija-feedback");
        window.location.reload();
      }
      if(program_id ==4){
        props.history.push("/kaivalya-feedback");
        window.location.reload();
      }
      if(program_id ==5){
        props.history.push("/vision-feedback");
        window.location.reload();
      }
    }

    const { isEventOnWish, addToEventWish } = useWish();
  
    const addEvent = (e) => {
        var source = e.currentTarget.getAttribute("data-id");
        addToEventWish(source);
    };

    const handleRegister = (e) => { 
        let program_id = e.target.dataset.programid;
        let event_id = e.target.dataset.eventid;
        localStorage.setItem("navtype", program_id);
        localStorage.setItem("event_id", event_id);
        if(program_id =='1'){
          props.history.push("/ulchemy");
          window.location.reload();
        }
        if(program_id =='2'){
          props.history.push("/ulchemy-elite");
          window.location.reload();
        }
        if(program_id =='3'){
          props.history.push("/divija");
          window.location.reload();
        }
        if(program_id =='4'){
          props.history.push("/kaivalya");
          window.location.reload();
        }
        if(program_id =='5'){
          props.history.push("/vision");
          window.location.reload();
        }
        if(program_id =='6'){
          props.history.push("/shivratri");
          window.location.reload();
        }
        if(program_id =='7'){
          props.history.push("/karmayogam");
          window.location.reload();
        }
        if(program_id =='8'){
          props.history.push("/paradesham");
          window.location.reload();
        }
    };
    const copyToClipEventBoard = async copyMe => {
        try {
          if(copyMe =='1'){
            var links = `${window.location.origin.toString()}/ulchemy`;
          }
          if(copyMe =='2'){
            var links = `${window.location.origin.toString()}/ulchemy-elite`;
          }
          if(copyMe =='3'){
            var links = `${window.location.origin.toString()}/divija`;
          }
          if(copyMe =='4'){
            var links = `${window.location.origin.toString()}/kaivalya`;
          }
          if(copyMe =='5'){
            var links = `${window.location.origin.toString()}/vision`;
          }
          if(copyMe =='6'){
            var links = `${window.location.origin.toString()}/shivratri`;
          }
          if(copyMe =='7'){
            var links = `${window.location.origin.toString()}/karmayogam`;
          }
          if(copyMe =='8'){
            var links = `${window.location.origin.toString()}/paradesham`;
          }
          setShareLink(links)
          setShareOpen(true);
          await navigator.clipboard.writeText(links);
          toast('Link Copied Successfully', {
            theme: "dark"
          });
        } catch (err) {
    
        }
      };

	const [shareopen, setShareOpen] = useState(false);
	const [sharelink, setShareLink] = useState('');
	const onShareOpenModal = async copyMe => {
        try {
			var link = copyMe.match(/\bhttps?:\/\/\S+/gi);
			var final_link = link[0].replace(/^"|"$/g, '');
			setShareLink(final_link)
			setShareOpen(true);
			await navigator.clipboard.writeText(final_link);
			toast('Link Copied Successfully', {
				theme: "dark"
			});
			
        } catch (err) {
    
        }
    };
    const onShareCloseModal = () => setShareOpen(false);
  return (
    <div>
        <section className="section-album">
			<div className="container">
				<div className="row">
					<div className="col-sm-12">
                    <div className="wisdom-btn"><Link to={"/contact"} className="registerbtn">I'm interested</Link></div>
						<div className="title-sec">
                            <h1 className="text-center">Upcoming Events</h1>
						</div>
					</div>
					
					<div className="col-sm-12">
                        { category && category.map((category, catindex) => (        
						<div className="row" key={catindex}>
                            <div className="col-md-12">
								<div className="title-sec"><h3>{ category.name} </h3>
                                </div>
							</div>
                            <div className="col-lg-12 col-md-12">
                                { category.events && category.events.map((event, eventindex) => (
                                    <div className="col-md-3" key={eventindex}>
                                        <div className="thumb-box">
                                            <div className="thumb-img" data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}>
                                            <div className="media-img mediaupcome-img">
                                                <img src={ event.event_image } alt="" onError={(e)=>{e.target.src='/img/placeholder.png'}}/>
                                            </div>
                                            <div className="additional-info" data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}>
                                                <div className="thumb-round">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37"><g fill="none" stroke="#44d5bf" strokeMiterlimit="10"><path stroke="#44d5bf" d="M18.5 36.248h-.017a.468.468 0 01-.441-.365c-.151-.675-.424-1.169-.939-1.706-.456-.476-1.049-.908-1.677-1.364-.978-.717-2.085-1.524-2.891-2.683-.839-1.204-1.23-2.608-1.192-4.278-.369.038-.725.058-1.062.058-3.527 0-4.902-2.112-6.116-3.974-.447-.687-.87-1.333-1.382-1.877-.541-.569-1.095-.933-1.696-1.108a.47.47 0 01.028-.907c.675-.152 1.169-.425 1.708-.939.474-.455.906-1.048 1.367-1.676.664-.912 1.417-1.943 2.456-2.73 1.203-.912 2.603-1.355 4.277-1.355.074 0 .15 0 .227.002-.458-4.33 1.859-5.838 3.913-7.178.688-.447 1.335-.87 1.877-1.382.572-.541.935-1.096 1.11-1.696a.467.467 0 01.907.027c.151.674.422 1.169.939 1.707.456.475 1.049.907 1.676 1.367.978.713 2.087 1.523 2.893 2.68.838 1.204 1.229 2.608 1.19 4.28.368-.04.724-.06 1.063-.06 3.526 0 4.901 2.111 6.116 3.971.447.688.87 1.337 1.383 1.878.54.571 1.094.935 1.695 1.11a.47.47 0 01-.027.908c-.677.149-1.17.418-1.707.937-.476.454-.91 1.049-1.365 1.674-.668.91-1.421 1.945-2.458 2.731-1.205.91-2.605 1.357-4.279 1.357l-.224-.003c.456 4.329-1.859 5.839-3.916 7.177-.687.447-1.334.872-1.877 1.384-.57.539-.933 1.092-1.109 1.694a.469.469 0 01-.45.339z"></path><path stroke="#44d5bf" d="M18.479 28.59h-.033a.466.466 0 01-.391-.269c-.174-.374-.406-.595-.697-.878-.302-.292-.646-.623-.976-1.172-.771-1.289-.989-3.092-.617-4.863a8.485 8.485 0 01-2.144.292c-1.257 0-2.348-.329-3.151-.948-.331-.256-.564-.553-.792-.843-.289-.371-.562-.72-1.055-1.038a.465.465 0 01.055-.816c.372-.174.595-.406.877-.697.292-.303.624-.646 1.174-.976.857-.513 1.986-.795 3.182-.795.561 0 1.122.06 1.68.177-.447-1.672-.492-3.806.657-5.293.256-.333.554-.565.843-.792.37-.288.718-.562 1.036-1.055a.469.469 0 01.819.055c.175.372.404.595.698.877.301.292.644.624.974 1.174.77 1.287.988 3.09.617 4.862a8.485 8.485 0 012.145-.291c1.258 0 2.348.328 3.152.948.33.256.565.554.79.843.29.369.562.717 1.056 1.035a.468.468 0 01-.056.819c-.372.174-.595.403-.876.696-.295.301-.623.643-1.174.976-.855.512-1.986.796-3.182.796-.562 0-1.125-.06-1.682-.18.449 1.673.492 3.809-.656 5.295-.258.332-.555.566-.845.792-.369.29-.717.563-1.037 1.056a.463.463 0 01-.391.213z"></path></g><path stroke="#44d5bf" fill="none"  strokeMiterlimit="10" d="M13.609 31.368c-.95 0-1.873-.195-2.766-.382-.797-.169-1.55-.326-2.29-.349l-.164-.002c-.707 0-1.299.136-1.809.413a.462.462 0 01-.563-.089.461.461 0 01-.054-.566c.367-.581.524-1.12.538-1.86.015-.653-.099-1.373-.218-2.136-.184-1.19-.395-2.538-.147-3.919.257-1.434.968-2.696 2.17-3.841-3.362-2.72-2.795-5.409-2.293-7.794.167-.796.327-1.55.346-2.289.023-.781-.113-1.427-.411-1.973a.466.466 0 01.658-.615c.58.366 1.12.523 1.858.538h.111c.625 0 1.307-.105 2.028-.219.826-.128 1.679-.261 2.578-.261 2.04 0 3.7.729 5.182 2.284 1.475-1.822 3.082-2.677 5.027-2.677.952 0 1.873.195 2.768.383.796.167 1.549.327 2.289.347l.163.003c.708 0 1.3-.135 1.809-.414a.465.465 0 01.617.658c-.365.58-.521 1.12-.538 1.857-.012.655.099 1.376.218 2.139.187 1.188.396 2.537.15 3.916-.257 1.434-.971 2.697-2.173 3.843 3.362 2.723 2.797 5.408 2.294 7.794-.168.795-.325 1.551-.348 2.291-.021.78.113 1.423.412 1.97a.458.458 0 01-.09.561.465.465 0 01-.567.059c-.58-.368-1.119-.525-1.858-.542-.655-.014-1.372.098-2.137.219-.827.13-1.681.262-2.578.262-2.039 0-3.699-.727-5.182-2.282-1.474 1.821-3.085 2.673-5.03 2.673z"></path><path stroke="#44d5bf" fill="none"  strokeMiterlimit="10" d="M13.978 25.855c-.267 0-.524-.032-.772-.063a6.475 6.475 0 00-.784-.061c-.244 0-.478.024-.715.075a.464.464 0 01-.443-.146.464.464 0 01-.085-.462c.142-.391.136-.715.128-1.126-.007-.422-.015-.905.142-1.531.37-1.474 1.507-2.919 3.045-3.918-1.518-.872-3.083-2.366-3.325-4.253-.054-.418-.007-.797.037-1.164.058-.471.111-.916-.013-1.499a.457.457 0 01.605-.528c.303.109.57.131.879.131l.25-.003.284-.002c.333 0 .74.017 1.25.145 1.472.37 2.917 1.507 3.917 3.045.871-1.518 2.367-3.083 4.252-3.325.127-.016.258-.024.391-.024.27 0 .525.031.775.061s.507.062.781.062c.246 0 .478-.024.715-.075a.455.455 0 01.444.147.465.465 0 01.086.458c-.142.393-.136.717-.129 1.129.007.425.018.904-.142 1.533-.37 1.472-1.508 2.917-3.047 3.916 1.52.872 3.085 2.366 3.326 4.251.054.418.007.798-.037 1.166-.058.472-.11.917.015 1.496a.464.464 0 01-.147.445.469.469 0 01-.46.086 2.447 2.447 0 00-.877-.134c-.083 0-.165.002-.248.005l-.283.002c-.335 0-.744-.016-1.251-.146-1.473-.367-2.918-1.506-3.919-3.046-.871 1.521-2.365 3.085-4.251 3.327a2.814 2.814 0 01-.394.026z"></path></svg>
                                                </div>
                                                
                                                <div className="info-share">
                                                <p className={ isEventOnWish(event.id) ? 'second wished' : 'second'} onClick={addEvent} data-id={event.id}>
                                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" className="svg-inline--fa fa-heart fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>
                                                </p>
                                                <p className="first" data-for="share" data-tip="Click to Copy the Link" data-iscapture="true" onClick={ () => copyToClipEventBoard(event.program_id) }><span className="fa fa-share-alt"></span></p>
                                                </div>
                                                <p className="additional-content">{ event.event_desc && event.event_desc.length > 90 ? event.event_desc.substring(0, 90)+ "..."  : event.event_desc }</p>
                                            </div>
                                            </div>
                                            
                                            <div className="upcome-content">
                                            <h4 data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}>{ event.event_name }</h4>
                                            <ul>
                                                <li data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}><i className="rt-icon2-calendar2"></i> { event.event_date }</li>
                                                <li data-eventid={event.id} data-programid={event.program_id} onClick={handleRegister}><i className="rt-icon2-location-outline"></i> { event.event_address }</li>
                                            </ul>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                }
                            </div>
						</div>
                        ))}
					</div>
				</div>
			</div>
		</section>

	<Modal open={shareopen} onClose={onShareCloseModal} center>
      <div className='player-wrapper shareblock'>
	  	<a href={"https://api.whatsapp.com/send?text="+sharelink} target="_blank"><img src="/img/whatsapp.png" alt="" className="shareicon"/></a>
		<a href={"https://www.facebook.com/sharer/sharer.php?u="+sharelink} target="_blank"><img src="/img/facebook.png" alt="" className="shareicon"/></a>
      </div>
    </Modal>
    <ReactTooltip
      id="share"
      place='bottom'
      multiline={true}
    />
    <ToastContainer/>
    </div>
  );
};

export default Upcoming;
